import { render } from "./profileView.vue?vue&type=template&id=553d9e5b"
import script from "./profileView.vue?vue&type=script&lang=js"
export * from "./profileView.vue?vue&type=script&lang=js"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__